import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaCheck, FaWhatsapp } from "react-icons/fa";
import { VITRIN_URUNLERI, vitrinIcerik } from "../../data/vitrinUrunleri";

const WHATSAPP_NUMARA = "905377981129";

/**
 * Ana sayfanın en üstündeki büyük tanıtım alanı — öne çıkarılan yeni ürünler.
 * İlk ürün geniş gösterilir; birden fazla ürün olursa diğerleri altında küçük kartlar olarak durur.
 */
export default function VitrinTanitim() {
  const { t, i18n } = useTranslation();
  const dil = (i18n.language || "tr").split("-")[0];
  if (!VITRIN_URUNLERI.length) return null;

  const [ana, ...digerleri] = VITRIN_URUNLERI;
  const icerik = vitrinIcerik(ana, dil);

  return (
    <section className="relative overflow-hidden bg-ink text-white">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(640px 420px at 88% 30%, rgba(194,65,12,.42), transparent 62%), radial-gradient(520px 420px at 0% 100%, rgba(22,116,174,.28), transparent 60%)",
        }}
      />
      <div className="container-page relative grid items-center gap-8 py-10 sm:py-14 lg:grid-cols-[1.15fr_1fr] lg:gap-14">
        <div className="text-start">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent px-3 py-1 text-[11.5px] font-bold uppercase tracking-wide">
            {t("spotlight.newInStore")}
          </span>
          <h2 className="mt-5 text-[32px] font-bold text-white leading-[1.06] tracking-[-0.03em] sm:text-[46px]">{icerik.ad}</h2>
          <p className="mt-3 text-[18px] font-semibold text-orange-300 sm:text-[21px]">{icerik.slogan}</p>
          <ul className="mt-6 grid gap-2.5 text-[14.5px] text-white/85 sm:grid-cols-2">
            {icerik.avantajlar.slice(0, 4).map((a) => (
              <li key={a.baslik} className="flex items-center gap-2.5">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-500/20 text-emerald-400">
                  <FaCheck size={10} aria-hidden="true" />
                </span>
                {a.baslik}
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to={`/yeni/${ana.slug}`}
              className="inline-flex items-center gap-2 rounded-md bg-white px-5 py-3 text-[14.5px] font-semibold text-ink transition-colors hover:bg-orange-100"
            >
              {t("spotlight.homeCta")}
              <span aria-hidden="true" className="arrow-forward" />
            </Link>
            <a
              href={`https://wa.me/${WHATSAPP_NUMARA}?text=${encodeURIComponent(icerik.whatsapp)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-md bg-[#25D366] px-5 py-3 text-[14.5px] font-semibold text-white transition-colors hover:bg-[#1ebe5b]"
            >
              <FaWhatsapp size={17} aria-hidden="true" />
              {t("spotlight.whatsapp")}
            </a>
          </div>
        </div>

        <Link to={`/yeni/${ana.slug}`} className="group relative mx-auto block w-full max-w-[460px]" aria-label={icerik.ad}>
          <div className="overflow-hidden rounded-2xl bg-[#e9e8e4] shadow-[0_40px_80px_-30px_rgba(0,0,0,.75)]">
            <img
              src={ana.gorsel}
              alt={icerik.ad}
              className="aspect-square w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
            />
          </div>
          {ana.temsiliGorsel && (
            <span className="mt-2 block text-end text-[11px] text-white/40">{t("spotlight.illustrative")}</span>
          )}
        </Link>
      </div>

      {digerleri.length > 0 && (
        <div className="container-page relative grid gap-3 pb-10 sm:grid-cols-2 lg:grid-cols-3">
          {digerleri.map((v) => {
            const ic = vitrinIcerik(v, dil);
            return (
              <Link
                key={v.slug}
                to={`/yeni/${v.slug}`}
                className="flex items-center gap-4 rounded-xl border border-white/10 bg-white/5 p-3 text-start transition-colors hover:bg-white/10"
              >
                <img src={v.gorsel} alt="" className="h-16 w-16 shrink-0 rounded-lg bg-[#e9e8e4] object-cover" />
                <span className="min-w-0">
                  <span className="block text-[11px] font-bold uppercase tracking-wide text-orange-300">{t("spotlight.newBadge")}</span>
                  <span className="block truncate text-[15px] font-semibold">{ic.ad}</span>
                  <span className="block truncate text-[12.5px] text-white/60">{ic.slogan}</span>
                </span>
              </Link>
            );
          })}
        </div>
      )}
    </section>
  );
}
